import React from 'react';
import toti from './icons/toti-3.png';
import './uiStyles.css'

export const TotiHead = () => {
  return (
    <>
        <img className='toti' src={toti}/>
    </>
  )
}

export default TotiHead;